import React from "react";
import PropTypes from "prop-types";
import { CLIENT_LEDGER_ENTRY_TYPES, CLIENT_LEDGER_TYPE_LABELS, PAYMENT_METHOD_LABELS, formatLedgerAmount } from "./clientLedgerTypes";

const isManualEntry = entry => (
  entry.type === CLIENT_LEDGER_ENTRY_TYPES.PAYMENT ||
  entry.type === CLIENT_LEDGER_ENTRY_TYPES.OPENING_BALANCE
);

function ClientLedgerList({ entries, onEdit, onDelete }) {
  return (
    <div>
      <div className="row table-header manage-table-title text-center mx-0">
        <div className="col-md-2 table-cell">Data</div>
        <div className="col-md-2 table-cell">Typ</div>
        <div className="col-md-2 table-cell">Miesiac</div>
        <div className="col-md-2 table-cell">Kwota</div>
        <div className="col-md-2 table-cell">Metoda</div>
        <div className="col-md-1 table-cell">Notatka</div>
        <div className="col-md-1 table-cell">Akcje</div>
      </div>
      {entries.map((entry, index) => (
        <div key={entry.id} className={`table-row row d-flex manage-text text-center mx-0 ${index % 2 !== 0 ? "table-row-alternate" : ""}`}>
          <div className="col-md-2 table-cell">{entry.date}</div>
          <div className="col-md-2 table-cell">{CLIENT_LEDGER_TYPE_LABELS[entry.type]}</div>
          <div className="col-md-2 table-cell">{entry.settlementMonth}</div>
          <div className="col-md-2 table-cell">{formatLedgerAmount(entry.amount)}</div>
          <div className="col-md-2 table-cell">{PAYMENT_METHOD_LABELS[entry.method] || entry.method}</div>
          <div className="col-md-1 table-cell">{entry.note}</div>
          <div className="col-md-1 table-cell">
            {isManualEntry(entry) && (
              <>
                <button type="button" className="btn btn-link btn-sm p-0 mr-2" aria-label={`Edytuj ${entry.id}`} onClick={() => onEdit(entry)}>
                  Edytuj
                </button>
                <button type="button" className="btn btn-link btn-sm p-0 text-danger" aria-label={`Usun ${entry.id}`} onClick={() => onDelete(entry)}>
                  Usun
                </button>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

ClientLedgerList.propTypes = {
  entries: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ClientLedgerList;
